/* eslint-disable  react/jsx-indent */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ModalContext } from 'App';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ConfirmAlertOpposite from 'modules/common/components/ConfirmAlertOpposite';
import ValidateTicketModal from '../components/ValidateTicketModal';
// import PrintOVRReceipt from '../components/PrintOVRReceipt';
import VerifyReceipt from '../components/VerifyReceipt';
import Discount from '../components/Discount';
// import GenerateSOA from '../components/GenerateSOA';
import ViewSOA from '../components/ViewSOA';
import ViewOR from '../components/ViewOR';
import * as actions from '../action';
import * as c from '../constant';

function OVRSApplicationContent({
  applyingPenalty,
  permissions,
  ovrsId,
  isAssessing,
  validateTicket,
  showTransaction,
  ovrsInfo,
  isLoading,
  taxpayerProfile,
  ovrInfo,
  startAssessment,
  isValidating,
  isReceiving,
  tagAsReceived,
  tagAsPrintedTransaction,
  applyPenalty,
  generateSOA,
  regenerateSOA,
  cancelSoa,
  cancelApplication,
  isCancelling,
  isCancellingApplication,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = ovrsId;
  useEffect(() => {
    if (_.isEmpty(ovrsId)) return;
    showTransaction(ovrsId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(ovrsId)) return;
    showTransaction(ovrsId);
  }, [ovrsId]);

  const handleValidateTicket = () => {
    validateTicket({ ovr_number: _.get(ovrInfo, 'ovr_number') }, res => {
      setModal({
        isOpen: true,
        content: <ValidateTicketModal id={selectedTransaction} ticket={res} />,
        title: `OVRS Validation Result`,
        modalSize: 'modal-xl',
      });
    });
  };

  // const serialNo =
  //   _.get(ovrsInfo, 'included.module.attributes.serial_number') || 0;

  const onStartAssessment = () => e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want start assessment?`,
      () => {
        startAssessment(selectedTransaction, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const getInitials = cString => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const showVerifyReceipt = status => {
    return ['WAITING FOR PAYMENT', 'PAID', 'FOR PICK-UP', 'PENDING'].includes(
      status
    );
  };

  // const showGenerateSOA = (status, soa_number) => {
  //   if (['COMPUTED'].includes(status)) {
  //     if (soa_number) {
  //       return false;
  //     }
  //     return true;
  //   }
  //   return false;
  // };

  const onReceive = e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as received this OVR Application?',
      remarks => {
        startAssessment(selectedTransaction, () => {
          tagAsReceived(selectedTransaction, { remarks }, () => {
            showTransaction(selectedTransaction);
          });
        });
      },
      () => {
        setModal({ isOpen: false });
        showTransaction(selectedTransaction);
      },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleON = e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as printed this application?',
      remarks => {
        startAssessment(_.get(ovrsInfo, 'id'), () => {
          tagAsPrintedTransaction(
            _.get(ovrsInfo, 'id'),
            {
              remarks,
            },
            () => {
              showTransaction(_.get(ovrsInfo, 'id'));
            }
          );
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // const onPrintOVR = e => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: <PrintOVRReceipt data={ovrInfo} id={selectedTransaction} />,
  //     title: 'Print OR Receipt',
  //     modalSize: 'modal-md',
  //   });
  // };

  const handleDiscount = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <Discount
          transactionInfo={ovrsInfo}
          id={selectedTransaction}
        />
      ),
      title: `Discount`,
      modalSize: 'modal-sm',
    });
  };

  const handleVerifyReceipt = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={ovrsInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  // const handleGenerateSOA = e => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <GenerateSOA data={ovrsInfo} id={selectedTransaction} />
  //     ),
  //     title: `Generate SOA`,
  //     modalSize: 'modal-lg',
  //   });
  // };

  const handleCancelApplication = e => {
    e.preventDefault();
    ConfirmAlertOpposite(
      "Cancel Application",
      `Are you sure, you want to cancel this application?`,
      (remarks) => {
        cancelApplication(
          _.get(ovrsInfo, 'id'),
          remarks,
          {},
          () => {
            showTransaction(_.get(ovrsInfo, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true,
    );
  };

  const handleCancelSoa = e => {
    e.preventDefault();
    ConfirmAlertOpposite(
      "Cancel SOA",
      `Are you sure, you want to cancel this application's SOA?`,
      (remarks) => {
        cancelSoa(
          _.get(ovrsInfo, 'id'),
          remarks,
          {},
          () => {
            showTransaction(_.get(ovrsInfo, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true,
    );
  };

  const handleViewSOA = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewSOA data={ovrsInfo} id={selectedTransaction} />,
      title: `View e-SOA`,
      modalSize: 'modal-xl',
    });
  };

  const handleApplyPenalty = e => {
    e.preventDefault();
    applyPenalty(selectedTransaction, {}, () => {
      showTransaction(_.get(ovrsInfo, 'id'));
    });
  };

  const handleViewOR = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOR id={selectedTransaction} />,
      title: 'Print OR Receipt',
      modalSize: 'modal-xl',
    });
  };

  const handleGenerateSOA = e => {
    e.preventDefault();

    ConfirmAlert(
      `Are you sure, you want generate SOA for this application?`,
      () => {
        generateSOA(_.get(ovrsInfo, 'id'), {}, () => {
          showTransaction(_.get(ovrsInfo, 'id'));
          setModal({
            isOpen: true,
            content: (
              <ViewSOA data={ovrsInfo} id={selectedTransaction} />
            ),
            title: `View e-SOA`,
            modalSize: 'modal-xl',
          });
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleRegenerateSOA = e => {
    e.preventDefault();

    ConfirmAlert(
      `Are you sure, you want regenerate SOA for this application?`,
      () => {
        regenerateSOA(_.get(ovrsInfo, 'id'), {}, () => {
          showTransaction(_.get(ovrsInfo, 'id'));
          setModal({
            isOpen: true,
            content: (
              <ViewSOA data={ovrsInfo} id={selectedTransaction} />
            ),
            title: `View e-SOA`,
            modalSize: 'modal-xl',
          });
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="container-fluid card-section-content">
      {isLoading ||
        isAssessing ||
        (isReceiving && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ))}
      {!_.isEmpty(ovrsInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="row highlight d-flex align-items-center mx-3 py-3">
              <div className="col-12 px-0 mt-0 mb-1 ">
                {/* BORDER */}
                <div className="card border-primary p-2">
                  <div className="container-fluid py-1">
                    <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                      <div className="d-flex round-image justify-content-center">
                        <h3 className="d-flex align-items-center initials mb-0">
                          {_.get(taxpayerProfile, 'photo') !==
                            '-/format/jpeg/' ? (
                            <img
                              alt="Client Profile"
                              src={_.get(taxpayerProfile, 'photo')}
                            />
                          ) : (
                            getInitials(
                              `${_.get(ovrInfo, 'first_name')} ${_.get(
                                ovrInfo,
                                'middle_name'
                              )} ${_.get(ovrInfo, 'last_name')}`
                            )
                          )}
                        </h3>
                      </div>
                      <div className="d-flex ml-4 align-items-center">
                        <h1 className="transaction-company m-0">
                          {`${_.get(ovrInfo, 'first_name') || '-'} ${_.get(
                            ovrInfo,
                            'middle_name'
                          ) || ''} ${_.get(ovrInfo, 'last_name') || ''} ${_.get(
                            ovrInfo,
                            'extension_name'
                          ) || ''}`}
                        </h1>
                      </div>
                    </div>
                    <div className="d-flex ml-auto justify-content-end mb-3">
                      {showVerifyReceipt(
                        _.get(
                          ovrsInfo,
                          'attributes.transaction_status'
                        )
                      ) &&
                        Acl(permissions, ['OVRS ASSESS PAYMENT RECEIPT']) && (
                          <button
                            onClick={handleVerifyReceipt}
                            className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                            type="button"
                          >
                            Assess Payment Receipt
                          </button>
                        )}
                      {Acl(permissions, ['ALLOW OVRS DISCOUNT']) &&
                        [
                          'COMPUTED',
                          'PENDING',
                          'EXPIRED REFERENCE NUMBER',
                        ].indexOf(
                          _.get(
                            ovrsInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 && (
                          <button
                            onClick={handleDiscount}
                            type="button"
                            className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                          >
                            Apply Discount
                          </button>
                        )}
                      {Acl(permissions, ['OVRS VIEW SOA']) &&
                        ['PENDING', 'WAITING FOR PAYMENT'].indexOf(
                          _.get(
                            ovrsInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 &&
                        _.get(ovrsInfo, 'attributes.soa_number') ? (
                        <button
                          onClick={handleViewSOA}
                          className="btn gen-btn btn-primary cms-bg-color-primary font-weight-bold mx-2"
                          type="button"
                        >
                          View SOA
                        </button>
                      ) : (
                        ''
                      )}
                      {/* {Acl(permissions, ['OVRS GENERATE SOA']) &&
                        _.get(ovrsInfo, 'attributes.soa_number') &&
                        _.get(
                          ovrsInfo,
                          'attributes.transaction_status'
                        ) === 'PENDING' && (
                          <button
                            onClick={handleGenerateSOA}
                            className="btn gen-btn btn-primary cms-bg-color-primary font-weight-bold ml-2"
                            type="button"
                          >
                            Re-Generate SOA
                          </button>
                        )} */}
                      {['COMPUTED'].indexOf(
                        _.get(
                          ovrsInfo,
                          'attributes.transaction_status'
                        )
                      ) > -1 &&
                        //  showGenerateSOA(_.get(
                        //   ovrsInfo,
                        //   'attributes.transaction_status'
                        // ), _.get(ovrsInfo, 'attributes.soa_number'))
                        Acl(permissions, ['OVRS GENERATE SOA']) && (
                          <button
                            onClick={handleGenerateSOA}
                            className="btn gen-btn btn-primary cms-bg-color-primary font-weight-bold ml-2"
                            type="button"
                          >
                            Generate SOA
                          </button>
                        )}
                      {Acl(permissions, ['OVRS CANCEL SOA']) &&
                        [
                          'PENDING',
                          'EXPIRED SOA',
                          'EXPIRED REFERENCE NUMBER',
                        ].indexOf(
                          _.get(
                            ovrsInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 && _.get(ovrsInfo, 'attributes.soa_generated_at') !== null && (
                          <button
                            disabled={isCancelling}
                            type="button"
                            onClick={handleCancelSoa}
                            className="btn gen-btn btn-danger text-white font-weight-bold mx-2"
                          >
                            {isCancelling ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                <i className="fas fa-times py-2 mr-2" />
                                Cancel SOA
                              </>
                            )}
                          </button>
                        )}

                      {['EXPIRED REFERENCE NUMBER', 'EXPIRED SOA'].indexOf(
                        _.get(
                          ovrsInfo,
                          'attributes.transaction_status'
                        )
                      ) > -1 &&
                        Acl(permissions, ['OVRS REGENERATE SOA']) && (
                          <button
                            disabled={isLoading}
                            onClick={handleRegenerateSOA}
                            type="button"
                            className="btn gen-btn btn-primary cms-bg-color-primary font-weight-bold ml-2"
                          >
                            Regenerate SOA
                          </button>
                        )}
                      {_.get(
                        ovrsInfo,
                        'attributes.transaction_status'
                      ) === 'PAID'
                        ? // && serialNo === 0
                        Acl(permissions, ['OVRS PRINT OVR']) && (
                          <button
                            type="button"
                            onClick={handleViewOR}
                            className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                          >
                            View OR &nbsp;&nbsp;
                            <i className="fas fa-print" />
                          </button>
                        )
                        : ''}
                      {_.get(
                        ovrsInfo,
                        'attributes.transaction_status'
                      ) === 'PAID'
                        ? // && serialNo !== 0
                        Acl(permissions, ['OVRS TAG AS PRINTED']) && (
                          <button
                            disabled={isAssessing}
                            type="button"
                            onClick={handleON}
                            className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                          >
                            {isAssessing ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                Tag as Printed &nbsp;&nbsp;
                                <i className="fas fa-check" />
                              </>
                            )}
                          </button>
                        )
                        : ''}
                      {['PRINTED'].indexOf(
                        _.get(
                          ovrsInfo,
                          'attributes.transaction_status'
                        )
                      ) > -1 &&
                        +_.get(
                          ovrsInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        Acl(permissions, ['OVRS TAG AS RECEIVE']) && (
                          <button
                            disabled={isAssessing || isReceiving}
                            type="button"
                            onClick={onReceive}
                            className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                          >
                            Tag as Received &nbsp;&nbsp;
                            <i className="fas fa-check" />
                          </button>
                        )}

                      {Acl(permissions, ['OVRS CANCEL APPLICATION']) &&
                        [
                          'FOR RESUBMISSION',
                          'FOR CHECKING',
                        ].indexOf(
                          _.get(
                            ovrsInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 && (
                          <button
                            disabled={isCancellingApplication}
                            type="button"
                            onClick={handleCancelApplication}
                            className="btn gen-btn btn-danger text-white font-weight-bold mx-2"
                          >
                            {isCancellingApplication ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                <i className="fas fa-times py-2 mr-2" />
                                Cancel Application
                              </>
                            )}
                          </button>
                        )}

                      {['FOR CHECKING'].indexOf(
                        _.get(
                          ovrsInfo,
                          'attributes.transaction_status'
                        )
                      ) > -1 &&
                        +_.get(
                          ovrsInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        _.get(
                          ovrsInfo,
                          'included.module.attributes.transmittal_no'
                        ) &&
                        Acl(permissions, ['OVRS START ASSESSMENT']) && (
                          <button
                            disabled={isAssessing}
                            type="button"
                            onClick={onStartAssessment(ovrsInfo)}
                            className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                          >
                            Start Assessment &nbsp;&nbsp;
                            <i className="fas fa-check" />
                          </button>
                        )}

                      {['FOR CHECKING'].indexOf(
                        _.get(
                          ovrsInfo,
                          'attributes.transaction_status'
                        )
                      ) > -1 &&
                        +_.get(
                          ovrsInfo,
                          'attributes.is_start_assessment'
                        ) === 1 &&
                        Acl(permissions, ['OVRS VALIDATE TICKET']) && (
                          <button
                            disabled={isValidating}
                            type="button"
                            onClick={handleValidateTicket}
                            className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                          >
                            Validate Ticket&nbsp;
                          </button>
                        )}
                      {_.get(ovrsInfo, 'attributes.status') !==
                        'PAID' &&
                        Acl(permissions, ['ALLOW OVRS DISCOUNT']) === false && (
                          <button
                            disabled={applyingPenalty}
                            onClick={handleApplyPenalty}
                            className="btn gen-btn btn-warning font-weight-bold mx-2"
                            type="button"
                          >
                            Apply Penalty
                          </button>
                        )}
                    </div>

                    <Tabs>
                      <TabList>
                        <Tab>Transaction</Tab>
                        <Tab>Ticket Information</Tab>
                      </TabList>
                      <TabPanel>
                        <TransactionInformation
                          transactionInfo={ovrsInfo}
                          taxpayer={taxpayerProfile}
                          module="ovrs"
                        />
                      </TabPanel>
                      <TabPanel>
                        <div className="col-12 p-3">
                          <div className="full-group border-bottom">
                            <div className="form-row">
                              {_.get(
                                ovrsInfo,
                                'attributes.soa_number'
                              ) ? (
                                <div className="cit-inner  mt-1 mb-3 col-12 ">
                                  <label className="font-weight-bold mb-0 mr-2 cit-label">
                                    SOA Number
                                    <span className="cit-span">:</span>
                                  </label>
                                  <button
                                    type="button"
                                    onClick={handleViewSOA}
                                    className="ml-1 btn btn-primary cms-bg-color-primary cms-outline-primary  btn-small"
                                  >
                                    {_.get(
                                      ovrsInfo,
                                      'attributes.soa_number'
                                    ) || ''}
                                  </button>
                                </div>
                              ) : (
                                ''
                              )}
                              <div className="col-12">
                                <hr className="cit-hr" />
                              </div>

                              <div className="cit-inner  mt-1 col-6 ">
                                <label className="font-weight-bold mb-0 mr-2 cit-label">
                                  OVR Number
                                  <span className="cit-span">:</span>
                                </label>
                                <span className="transaction-text p-0">
                                  {_.get(ovrInfo, 'ovr_number') || ''}
                                </span>
                              </div>
                              <div className="cit-inner  mt-1 col-6 ">
                                <label className="font-weight-bold mb-0 mr-2 cit-label">
                                  Name of Violator
                                  <span className="cit-span">:</span>
                                </label>
                                <span className="transaction-text text-uppercase p-0">
                                  {_.get(ovrInfo, 'last_name') || ''}{' '}
                                  {_.get(ovrInfo, 'first_name') || ''}{' '}
                                  {_.get(ovrInfo, 'middle_name') || ''}{' '}
                                  {_.get(ovrInfo, 'extension_name') || ''}{' '}
                                </span>
                              </div>
                              <div className="cit-inner  mt-1 col-6 ">
                                <label className="font-weight-bold mb-0 mr-2 cit-label">
                                  Valid ID to present
                                  <span className="cit-span">:</span>
                                </label>
                                <span className="transaction-text p-0">
                                  {_.get(ovrInfo, 'valid_id_to_present') ||
                                    'N/A'}
                                </span>
                              </div>
                            </div>
                            <div className="col-12">
                              <hr className="cit-hr" />
                            </div>

                            <div className="form-row">
                              <div className="cit-inner  mt-1 flex-column col-12 ">
                                <label className="font-weight-bold mb-0 mr-2 cit-label vticket">
                                  Violation Ticket
                                  <span className="cit-span">:</span>
                                </label>

                                <div className="vticket-container">
                                  <a
                                    href={
                                      _.get(ovrInfo, 'ticket_url') ||
                                      ImagePlaceholder
                                    }
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    <img
                                      className="img-responsive "
                                      alt=""
                                      src={
                                        _.get(ovrInfo, 'ticket_url') ||
                                        ImagePlaceholder
                                      }
                                    />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

OVRSApplicationContent.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  tagAsPrintedTransaction: PropTypes.instanceOf(Function).isRequired,
  tagAsReceived: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  applyPenalty: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  validateTicket: PropTypes.instanceOf(Function).isRequired,
  ovrsInfo: PropTypes.instanceOf(Object).isRequired,
  ovrsId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  ovrInfo: PropTypes.instanceOf(Object).isRequired,
  isAssessing: PropTypes.bool.isRequired,
  isValidating: PropTypes.bool.isRequired,
  isReceiving: PropTypes.bool.isRequired,
  applyingPenalty: PropTypes.bool.isRequired,
  generateSOA: PropTypes.instanceOf(Function).isRequired,
  regenerateSOA: PropTypes.instanceOf(Function).isRequired,
  cancelSoa: PropTypes.instanceOf(Function).isRequired,
  cancelApplication: PropTypes.instanceOf(Function).isRequired,
  isCancelling: PropTypes.bool.isRequired,
  isCancellingApplication: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  permissions: getJson('permissions'),
  ovrsList: _.get(api, `${c.GET_OVR_TRANSACTIONS}.list`) || [],
  ovrsInfo: _.get(api, `${c.SHOW_OVR}.item`) || {},
  isCancelling: _.get(api, 'loading', []).indexOf(c.CANCEL_SOA) > -1,
  isCancellingApplication: _.get(api, 'loading', []).indexOf(c.CANCEL_APPLICATION) > -1,
  isAssessing: _.get(api, 'loading', []).indexOf(c.START_ASSESSMENT) > -1,
  applyingPenalty: _.get(api, 'loading', []).indexOf(c.APPLY_PENALTY) > -1,
  isValidating:
    _.get(api, 'loading', []).indexOf(c.VALIDATE_OVR_TRANSACTION) > -1,
  isLoading: api.loading.indexOf(c.SHOW_OVR) > -1,
  isReceiving: api.loading.indexOf(c.TAG_AS_RECEIVE) > -1,
  ovrsId: _.get(match, 'params.ovrsId') || '',
  taxpayerProfile:
    _.get(api, `${c.SHOW_OVR}.item.included.taxPayer.attributes`) || {},
  ovrInfo: _.get(api, `${c.SHOW_OVR}.item.included.module.attributes`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OVRSApplicationContent);
